var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BillingDeletedList"},[_c('BillingDeletedGrid',{attrs:{"bills":_vm.bills}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }